import React, { Fragment } from 'react';
import { condenseHeader, openDepartment6yrs } from './utils';
import { getFullOITHardwareDeviceReport_6yrs } from './api';

import { Loader } from '../../../components/Loader';
import Navbar from '../../../components/Navbar';
import ReactTable from 'react-table';
import { useQuery } from '@apollo/client';

export const DeviceRefreshReportPage = (props: any) => {
  const { loading, error, data } = useQuery(getFullOITHardwareDeviceReport_6yrs);

  const renderGrid = (noTotals: any) => {
    // let totals = data.getFullOITHardwareDeviceReport_6yrs.pop();

    const totalColumns = [
      {
        Header: condenseHeader('Department Name'),
        accessor: 'deptName',
        // width: 220,
        minWidth: 220,
        resizable: true,
        Cell: openDepartment6yrs,
        Footer: 'Totals of all Departments',
      },
      {
        Header: condenseHeader('# Desktops To Refresh'),
        accessor: 'numDesktopsToRefresh',
        minWidth: 85,
        resizable: true,
        Footer: data.getFullOITHardwareDeviceReport_6yrs[data.getFullOITHardwareDeviceReport_6yrs.length - 1].numDesktopsToRefresh.toString(),
      },
      {
        Header: condenseHeader('Total Desktops'),
        accessor: 'totalDesktops',
        minWidth: 90,
        resizable: true,
        Footer: data.getFullOITHardwareDeviceReport_6yrs[data.getFullOITHardwareDeviceReport_6yrs.length - 1].totalDesktops.toString(),
      },
      {
        Header: condenseHeader('# Laptops To Refresh'),
        accessor: 'numLaptopsToRefresh',
        minWidth: 90,
        resizable: true,
        Footer: data.getFullOITHardwareDeviceReport_6yrs[data.getFullOITHardwareDeviceReport_6yrs.length - 1].numLaptopsToRefresh.toString(),
      },
      {
        Header: condenseHeader('Total Laptops'),
        accessor: 'totalLaptops',
        minWidth: 80,
        resizable: true,
        Footer: data.getFullOITHardwareDeviceReport_6yrs[data.getFullOITHardwareDeviceReport_6yrs.length - 1].totalLaptops.toString(),
      },
      {
        Header: condenseHeader('# iPads to Refresh'),
        accessor: 'numIpadsToRefresh',
        minWidth: 90,
        resizable: true,
        Footer: data.getFullOITHardwareDeviceReport_6yrs[data.getFullOITHardwareDeviceReport_6yrs.length - 1].numIpadsToRefresh.toString(),
      },
      {
        Header: condenseHeader('Total iPads'),
        accessor: 'totalIpads',
        minWidth: 60,
        resizable: true,
        Footer: data.getFullOITHardwareDeviceReport_6yrs[data.getFullOITHardwareDeviceReport_6yrs.length - 1].totalIpads.toString(),
      },
      {
        Header: condenseHeader('# Tablets To Refresh'),
        accessor: 'numTabletsToRefresh',
        minWidth: 90,
        resizable: true,
        Footer: data.getFullOITHardwareDeviceReport_6yrs[data.getFullOITHardwareDeviceReport_6yrs.length - 1].numTabletsToRefresh.toString(),
      },
      {
        Header: condenseHeader('Total Tablets'),
        accessor: 'totalTablets',
        minWidth: 70,
        resizable: true,
        Footer: data.getFullOITHardwareDeviceReport_6yrs[data.getFullOITHardwareDeviceReport_6yrs.length - 1].totalTablets.toString(),
      },
      {
        Header: condenseHeader('# Devices To Refresh'),
        accessor: 'numDevicesToRefresh',
        minWidth: 90,
        resizable: true,
        Footer: data.getFullOITHardwareDeviceReport_6yrs[data.getFullOITHardwareDeviceReport_6yrs.length - 1].numDevicesToRefresh.toString(),
      },
      {
        Header: condenseHeader('Total Devices'),
        accessor: 'totalDevices',
        minWidth: 70,
        resizable: true,
        Footer: data.getFullOITHardwareDeviceReport_6yrs[data.getFullOITHardwareDeviceReport_6yrs.length - 1].totalDevices.toString(),
      },
      {
        Header: condenseHeader('Average Device Age (Years)'),
        accessor: 'avgYrsOld',
        resizable: true,
        Footer: data.getFullOITHardwareDeviceReport_6yrs[data.getFullOITHardwareDeviceReport_6yrs.length - 1].avgYrsOld.toString(),
      },
      {
        accessor: 'deptId',
        show: false,
      },
    ];

    return (
      <ReactTable
        pageSize={data.getFullOITHardwareDeviceReport_6yrs.length - 1}
        columns={totalColumns}
        filterable
        showPagination={false}
        className='-striped -highlight mb-5'
        data={noTotals}
      />
    );
  };

  if (loading) {
    return (
      <React.Fragment>
        <Navbar />
        <Loader />
      </React.Fragment>
    );
  }

  if (error) {
    return (
      <React.Fragment>
        <Navbar />
        <h2>Error loading data...</h2>
      </React.Fragment>
    );
  }

  if (data) {
    let noTotals = data.getFullOITHardwareDeviceReport_6yrs.slice(0, data.getFullOITHardwareDeviceReport_6yrs.length - 1);
    return (
      <Fragment>
        <Navbar />
        <div className='container-fluid mt-1'>
          <h2>OIT Hardware Device Refresh Report</h2>
          <div className='mt-3'>{renderGrid(noTotals)}</div>
        </div>
      </Fragment>
    );
  }
};
